<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container-fluid wow fadeIn">
            <legend>Users Report</legend>

            <b-row>
                <b-col sm="6" md="3">
                    <b-form-group label-size="sm" label="Date From:">
                        <b-form-input v-model="dateFrom" type="date" size="sm"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group label-size="sm" label="Date To:">
                        <b-form-input v-model="dateTo" type="date" size="sm"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group label-size="sm" label="Search:">
                        <b-form-input v-model="search" type="text" size="sm" placeholder="Name, username..."></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group label-size="sm" label="State:">
                        <b-form-select v-model="reachOutState" :options="reachOutStateOptions" size="sm"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col>
                    <b-button-group>
                        <b-button type="button" @click="getReport" variant="outline-dark">
                            Retrieve Report
                        </b-button>
                        <b-button type="button" @click="downloadCsv" variant="outline-success">
                            Download CSV
                        </b-button>
                        <b-button type="button" @click="exportCrmLeads" variant="outline-info">
                            Export Odoo CRM
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <strong>Total Records: {{totalRecords}}</strong>
                </b-col>
            </b-row>

            <div class="row pt-3">
                <div class="col">
                    <div class="table-responsive-md">
                    <b-table striped hover bordered small :items="items" :fields="fields">
                        <template #cell(actions)="data">
                            <router-link
                                class="btn btn-sm btn-outline-warning"
                                :to="{ path: '/userstate', query: { userId: data.item.id, fullName: data.item.fullName, userName: data.item.userName } }">
                                Update State
                            </router-link>
                        </template>
                    </b-table>
                    </div>
                    <br />
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination>
                </div>
            </div>

            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
        </div>
    </main>
</div>
